import { Card, CardBody, CardHeader, Col, Row } from "reactstrap";

// Shared layout of the HubSpot and EVERY8D cards: logo, status and action
// button in the header; description and [label, value] fields in the body.
const IntegrationCardLayout = ({
  logo,
  logoAlt,
  badge,
  action,
  description,
  fields,
  error,
}) => (
  <Card className="mb-0 h-100">
    <CardHeader className="d-flex align-items-center gap-3">
      <img src={logo} alt={logoAlt} className="integration-logo" />
      {badge}
      <div className="ms-auto">{action}</div>
    </CardHeader>
    <CardBody>
      <p className="text-muted fs-13 mb-4">{description}</p>
      <Row className="g-3">
        {fields.map(([label, value]) => (
          <Col key={label} xs={6}>
            <p className="text-muted fs-13 mb-1">{label}</p>
            <p className="fw-semibold mb-0">{value}</p>
          </Col>
        ))}
      </Row>
      {error}
    </CardBody>
  </Card>
);

export default IntegrationCardLayout;
